/**
 * Rebuy — Hide Quantity Selector on GWP & Hidden-Tag Line Items
 *
 * For any line item in the Rebuy SmartCart whose <li> carries either:
 *   - `property-_gwp:true` (auto-emitted by Rebuy from line item property `_gwp=true`)
 *   - `tag-hidden`         (emitted from the product's `hidden` tag)
 * remove the `.rebuy-cart__flyout-item-quantity` element so the customer
 * cannot change the quantity.
 */

(function RebuyHideQuantity() {
  'use strict';

  // The colon in `_gwp:true` must be escaped in a CSS selector.
  const TARGET_LI_SELECTOR = 'li.property-_gwp\\:true, li.tag-hidden';
  const QTY_SELECTOR = '.rebuy-cart__flyout-item-quantity-widget';

  function stripQuantityFromTargetItems() {
    document.querySelectorAll(TARGET_LI_SELECTOR).forEach((li) => {
      li.querySelectorAll(QTY_SELECTOR).forEach((el) => el.remove());
    });
  }

  // Run on next frame so we act after Rebuy has finished repainting the cart.
  function scheduleStrip() {
    requestAnimationFrame(stripQuantityFromTargetItems);
  }

  function bindRebuyEvents() {
    // Fires on add, remove, and quantity change.
    document.addEventListener('rebuy:cart.change', scheduleStrip);

    // SmartCart re-renders.
    document.addEventListener('rebuy:smartcart.ready', scheduleStrip);
    document.addEventListener('rebuy:smartcart.show', scheduleStrip);

    // Fallback event names used by some Rebuy widgets.
    document.addEventListener('rebuy.add', scheduleStrip);
    document.addEventListener('rebuy.change', scheduleStrip);
  }

  // Catch any re-render that the events above miss — Rebuy can replace
  // cart line item DOM out from under us.
  function observeCartMutations() {
    const observer = new MutationObserver(stripQuantityFromTargetItems);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    bindRebuyEvents();
    observeCartMutations();
    stripQuantityFromTargetItems();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
